export enum ReturnOrderReason {
  LADING = 1,
  FREE_TASTE = 2,
  PRGOODS = 3,
  PROTOTYPE = 4,
  RESERVE_SAMPLE = 5,
  INSPECTION = 6,
  GIVEAWAY = 7,
  MARKETING = 8,
  ORDER = 9,
  RETURN = 10,
  WAREHOUSE_TRANSFER = 11,
  TRANSFER = 12,
}

export const returnOrderReasonLabel: {
  [index: number]: string;
} = {
  [ReturnOrderReason.LADING]: "提品",
  [ReturnOrderReason.FREE_TASTE]: "試吃品",
  [ReturnOrderReason.PRGOODS]: "公關品",
  [ReturnOrderReason.PROTOTYPE]: "仿樣",
  [ReturnOrderReason.RESERVE_SAMPLE]: "留樣",
  [ReturnOrderReason.INSPECTION]: "檢驗",
  [ReturnOrderReason.GIVEAWAY]: "抽獎贈品",
  [ReturnOrderReason.MARKETING]: "行銷推廣",
  [ReturnOrderReason.ORDER]: "出貨",
  [ReturnOrderReason.RETURN]: "退倉",
  [ReturnOrderReason.WAREHOUSE_TRANSFER]: "移倉",
  [ReturnOrderReason.TRANSFER]: "調出",
};

export enum ReturnSubOrderReason {
  DEFECT = "瑕疵品",
  EXPIRATION_DATE_ISSUE = "效期問題",
  CUSTOMER_PERSONAL_REASON = "客人個人因素",
  MISSING_ITEM = "出貨缺件",
  PRICE_FACTOR = "價格因素",
  DUPLICATE_ORDER = "重複訂購",
  HIGH_RETURN_RATE = "迴轉過高",
  DISCONTINUED = "下架/停售",
  REORDER_FOR_DISCOUNT = "欲享有優惠折扣重新訂購",
  SHIPPING_ERROR = "出貨錯誤",
  OTHER = "其他",
}

export const returnSubOrderReasonOptions: { label: string; value: ReturnSubOrderReason }[] = [
  { label: ReturnSubOrderReason.DEFECT, value: ReturnSubOrderReason.DEFECT },
  { label: ReturnSubOrderReason.EXPIRATION_DATE_ISSUE, value: ReturnSubOrderReason.EXPIRATION_DATE_ISSUE },
  { label: ReturnSubOrderReason.CUSTOMER_PERSONAL_REASON, value: ReturnSubOrderReason.CUSTOMER_PERSONAL_REASON },
  { label: ReturnSubOrderReason.MISSING_ITEM, value: ReturnSubOrderReason.MISSING_ITEM },
  { label: ReturnSubOrderReason.PRICE_FACTOR, value: ReturnSubOrderReason.PRICE_FACTOR },
  { label: ReturnSubOrderReason.DUPLICATE_ORDER, value: ReturnSubOrderReason.DUPLICATE_ORDER },
  { label: ReturnSubOrderReason.HIGH_RETURN_RATE, value: ReturnSubOrderReason.HIGH_RETURN_RATE },
  { label: ReturnSubOrderReason.DISCONTINUED, value: ReturnSubOrderReason.DISCONTINUED },
  { label: ReturnSubOrderReason.REORDER_FOR_DISCOUNT, value: ReturnSubOrderReason.REORDER_FOR_DISCOUNT },
  { label: ReturnSubOrderReason.SHIPPING_ERROR, value: ReturnSubOrderReason.SHIPPING_ERROR },
  { label: ReturnSubOrderReason.OTHER, value: ReturnSubOrderReason.OTHER },
];
